import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetter'
})
export class FirstLetterPipe implements PipeTransform {

  transform(value: string): any {
      if (value) {
        return value.charAt(0).toUpperCase();
      }
  }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/firstLetter.pipe.ts